import { Arg, Metadata } from '../../../../utils/spds/metadata';
import CloseButton from '../../action/button/close.gjs';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import Title from './header/title.gjs';
import styles from './header.module.scss';

const METADATA = Metadata.define({
  description: 'Header for standard modal with title and close.',
  meta: {
    close: Arg.action({ description: 'Close action' }).required(),
    title: Arg.string({
      description: 'Header title',
      initialValue: 'Modal title',
    }),
    titleColumn: Arg.boolean({
      default: false,
      description: 'Render title in a column layout; only when using default title block',
    }),
    titleId: Arg.string({
      description:
        'Id for the header title element; Standard passes this so dialog aria-labelledby matches the title.',
    }),
  },
  name: 'Header',
});

export default class SpdsModalStandardHeader extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-standard-header';
  styles = styles;

  get closeBtnId() {
    return this.composeSubcomponentId('close-btn');
  }

  get titleColumn() {
    return this.argOrDefault('titleColumn');
  }

  get titleComponent() {
    return this.titleColumn ? FlexColumn : FlexRow;
  }

  get titleElementId() {
    return this.args.titleId ?? this.composeSubcomponentId('title');
  }

  get alignItems() {
    return this.args.alignItems ?? 'center';
  }

  get justifyContent() {
    return this.args.justifyContent ?? 'space-between';
  }

  <template>
    <FlexRow
      @alignItems={{this.alignItems}}
      @justifyContent={{this.justifyContent}}
      @tag="header"
      class={{this.classes}}
      data-test-spds-modal-standard-header
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      {{#if @title}}
        <Title @title={{@title}} id={{this.titleElementId}} />
      {{else}}
        <this.titleComponent
          class="spds-modal-standard-header-title"
          data-test-spds-modal-standard-header-title
          id={{this.titleElementId}}
        >
          {{yield}}
        </this.titleComponent>
      {{/if}}
      <CloseButton
        @close={{@close}}
        data-test-spds-modal-standard-header-close-button
        id={{this.closeBtnId}}
      />
    </FlexRow>
  </template>
}

export const MODAL_STANDARD_HEADER_METADATA = SpdsModalStandardHeader.metadata;
